import React from 'react';
import styles from './card-button.module.css';
import Iconify from '../../../../Iconify';
import { getCardBrandImage } from '../../utils/card-utils';

export const CardButton = ({ card, isSelected, onSelectedCard, onDeleteCard, children }) => {
  if (children) {
    return (
      <button
        onClick={() => onSelectedCard && onSelectedCard(card)}
        className={`${styles.cardButton} ${isSelected ? styles.cardButtonSelected : ''}`}
      >
        {children}
      </button>
    );
  }

  return (
    <button
      onClick={() => onSelectedCard(card)}
      className={`${styles.cardButton} ${isSelected ? styles.cardButtonSelected : ''}`}
    >
      <img src={getCardBrandImage(card.brand)} alt={card.brand} className={styles.cardLogo} />
      <span className={styles.cardNumber}>{card.card_number}</span>
      <span className={styles.cardExpiry}>
        {card.expiration_month}/{card.expiration_year}
      </span>
      {card.bank_name && <span className={styles.cardBank}>{card.bank_name}</span>}

      {onDeleteCard && (
        <button
          type="button"
          onClick={e => onDeleteCard(e, card)}
          className={styles.buttonToDeleteCard}
        >
          <Iconify icon="material-symbols:delete" />
        </button>
      )}
    </button>
  );
};

export const CardsGrid = ({ children }) => {
  return <div className={styles.cardsGrid}>{children}</div>;
};
